// extracted by mini-css-extract-plugin
export default {"App":"styles_App__cZp+K","tableContainer":"styles_tableContainer__qTz+A","logoutButton":"styles_logoutButton__YJETw","sidebarLogo":"styles_sidebarLogo__A5-Ma"};